import FrameTrigger from 'lib/clients/FrameTrigger';

export default class FrameTriggerClient<TriggerType, TriggerParams, Localizations = never> {
  private triggers: Array<FrameTrigger<TriggerType, TriggerParams, Localizations>>;

  constructor(triggers: Array<FrameTrigger<TriggerType, TriggerParams, Localizations>>) {
    // Triggers should be ordered by priority from highest to lowest.
    this.triggers = triggers;
  }

  public runTick(params: TriggerParams) {
    for (const trigger of this.triggers) {
      trigger.runTick(params);
    }
  }

  /**
   * Expected to always have 1 trigger showing.
   */
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  public getTriggered(): FrameTrigger<TriggerType, TriggerParams, Localizations> {
    for (const trigger of this.triggers) {
      if (trigger.isShowing) {
        return trigger;
      }
    }
  }
}
